import PropTypes from 'prop-types';
import React from 'react';
import AnimateHeight from 'react-animate-height';
import { useReframe } from 'nike-re-framejs';

import DataStateEnum, { PENDING } from '@/common/dataState';
import PendingLiveStreams from './PendingLiveStreams';
import LiveStreamsScoreboard from './LiveStreamsScoreboard';

function LiveStreams({ state, limited }) {
    const { derefSub } = useReframe();
    let liveStreamsIds = derefSub(['sub::liveStreams.matches.sorted.ids']);
    liveStreamsIds = limited ? liveStreamsIds.slice(0, 5) : liveStreamsIds;

    if (state === PENDING) {
        return <PendingLiveStreams />;
    }
    if (!liveStreamsIds || !liveStreamsIds.size) {
        return null;
    }
    return (
        <div className="animate-height-fix-ios">
            <AnimateHeight height={liveStreamsIds ? 'auto' : 0}>
                {liveStreamsIds.map(streamId => (
                    <LiveStreamsScoreboard streamId={streamId} key={streamId} />
                ))}
            </AnimateHeight>
        </div>
    );
}

LiveStreams.propTypes = {
    limited: PropTypes.bool,
    state: PropTypes.oneOf(Object.keys(DataStateEnum))
};

export default LiveStreams;
